import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import Modal from '../../../../common/modal/Modal';
import { postItineraryFood } from '../../../../../actions/itinerary/ItineraryAdditionalFood';
import { PUT } from '../../../../../config/permissions';
import withEndpointAuthorization from '../../../authorization/withEndPointAuthorization';
import { ITINERARY_ADDITIONAL_FOOD_ENDPOINT } from '../../../../../config/endpoints';
import ItineraryFoodForm from './ItineraryFoodForm';
import { tzNormalizeDate } from '../../../../../utils/date';

export const AddItineraryFoodButton = ({
  itineraryId,
  dispatchPostItineraryFood,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');

  const closeModal = () => setShowModal(false);

  const onModalSubmit = async (formValues) => {
    const payload = formValues.itineraryScheduleFoodRequestList
      ? formValues.itineraryScheduleFoodRequestList
          .filter(
            (foodRequest) =>
              foodRequest && foodRequest.supplierId && foodRequest.publicType,
          )
          .map((foodRequest) => ({
            supplierId:
              foodRequest.supplierId &&
              foodRequest.supplierId.value !== undefined
                ? foodRequest.supplierId.value
                : foodRequest.supplierId,

            publicType: Array.isArray(foodRequest.publicType)
              ? foodRequest.publicType.map((pt) =>
                  pt && pt.value !== undefined ? pt.value : pt,
                )
              : [
                  foodRequest.publicType &&
                  foodRequest.publicType.value !== undefined
                    ? foodRequest.publicType.value
                    : foodRequest.publicType,
                ],

            foodIds: Array.isArray(foodRequest.foodIds)
              ? foodRequest.foodIds
                  .map((food) =>
                    food && food.value !== undefined ? food.value : food,
                  )
                  .filter((foodId) => foodId !== null && foodId !== undefined)
              : [],

            scheduleDeliveredDate: foodRequest.scheduleDeliveredDate
              ? tzNormalizeDate({
                  date: foodRequest.scheduleDeliveredDate,
                })
              : null,
          }))
      : [];

    const response = await dispatchPostItineraryFood(itineraryId, payload);

    if (response) {
      closeModal();
    }
  };

  const openModal = () => {
    setShowModal(true);
  };

  const buildModalBody = () => {
    const newModalBody = (
      <ItineraryFoodForm onCancel={closeModal} handleProcess={onModalSubmit} />
    );
    setModalBody(newModalBody);
  };

  useEffect(() => {
    if (showModal !== false) {
      buildModalBody();
    }
  }, [showModal]);

  return (
    <>
      <Modal
        show={showModal}
        title="Asignar Alimentación"
        body={modalBody}
        size="lg"
      />
      <Button color="warning" className="border" onClick={openModal}>
        <i className="fa fa-cutlery" /> Asignar Alimentación
      </Button>
    </>
  );
};

AddItineraryFoodButton.propTypes = {
  itineraryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  dispatchPostItineraryFood: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostItineraryFood: postItineraryFood,
};

const connectedComponent = connect(
  null,
  mapDispatchToProps,
)(AddItineraryFoodButton);

export default withEndpointAuthorization({
  url: ITINERARY_ADDITIONAL_FOOD_ENDPOINT,
  permissionType: PUT,
})(connectedComponent);
